import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import UserContext from "../../context/user";

const useEventCancelMutation = (closeModal, setEventNavigation, setReservation) => {
  const { callApi } = useContext(UserContext);

  return useMutation(
    ({ eventId }) =>
      callApi(`/events/${eventId}/registrations`, {
        method: "DELETE",
      }),
    {
      onSuccess: () => {
        closeModal();
        setEventNavigation(null);
        setReservation();
      },
    }
  );
};

export default useEventCancelMutation;
